import { FC, useMemo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router';
import { JAPANESE_LOCALE } from '@link/share/constants';
import { FooterProps } from './footer.types';
import styles from './footer.module.css';

const Footer: FC<FooterProps> = ({ logo, year: yearProp }) => {
  const { t, i18n } = useTranslation();
  const year = yearProp ?? new Date().getFullYear();
  const isJa = useMemo(
    () => i18n.language === JAPANESE_LOCALE,
    [i18n.language]
  );

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.left}>
          <div className={styles.logo}>
            <img className={styles.logoImage} src={logo} alt="logo" />
          </div>
        </div>
        <div className={styles.right}>
          <ul className={styles.nav}>
            <li className={styles.navItem}>
              <Link to="terms" className={styles.navLink} target="_blank">
                {t('share.footer.terms')}
              </Link>
            </li>
            <li className={styles.navItem}>
              <Link to="privacy" className={styles.navLink} target="_blank">
                {t('views.privacy.title')}
              </Link>
            </li>
            <li className={styles.navItem}>
              <Link to="faq" className={styles.navLink} target="_blank">
                {t('views.faq.title')}
              </Link>
            </li>
          </ul>
          {isJa && (
            <ul className={styles.nav}>
              <li className={styles.navItem}>
                <Link to="law" className={styles.navLink} target="_blank">
                  {t('law.title')}
                </Link>
              </li>
            </ul>
          )}
          <div className={styles.info}>
            <p className={styles.cert}>{t('share.footer.cert')}</p>
            <p className={styles.copyright}>
              {t('share.footer.copyright', { year })}
            </p>
            <p className={styles.recaptcha}>
              <Trans
                i18nKey="share.footer.recaptchaNotice"
                t={t}
                components={{
                  PrivacyLink: (
                    <a
                      href="https://policies.google.com/privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                    />
                  ),
                  TermsLink: (
                    <a
                      href="https://policies.google.com/terms"
                      target="_blank"
                      rel="noopener noreferrer"
                    />
                  )
                }}
              />
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
